// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2lWPZ","selects":"Documents_selects__1p8pK"};